import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  getDefaultProps,
  BlockType,
  Shared,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type ContentCollectionItemType = {
  /** Place prop documentation here */
  image: Shared.Props.MediaProp;
  tagline: string;
  title: string;
  description: string;
  button: string;
  link: string;
  _darkColor?: string;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.None,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockTheme: BlockTheme.dark,
  blockType: BlockType.PrimaryCollection,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({
    image,
    tagline,
    title,
    description,
    button,
    link,
  }: ContentCollectionItemType) => (
    <Box className="primary-collection-content-collection-three-col-medium-media-v1">
      <Variants.LinkText className="link" href={link}>
        <Box className="layout423_image-wrapper">
          <Variants.Opacity
            variant="images.nonBackground"
            className="layout423_overlay"
          />
          {image.url ? (
            <Variants.ImageNoRadius
              src={image.url}
              loading="lazy"
              sizes="(max-width: 991px) 90vw, 28vw"
              // TODO: Can we use multiple images from source for different sizes
              srcSet={`${image.url} 500w, ${image.url} 800w, ${image.url} 1080w, ${image.url} 1600w, ${image.url} 1920w`}
              alt={image.alt}
              className="layout423_image"
            />
          ) : (
            <Box variant="images.nonBackground" className="layout423_image" />
          )}
        </Box>
        <Box className="layout423_card-content">
          {tagline && (
            <Box className="margin-bottom margin-xxsmall">
              <Variants.TagLine>{tagline}</Variants.TagLine>
            </Box>
          )}
          <Variants.Heading as="h3" variant="h4">
            {title}
          </Variants.Heading>
          <Box className="layout423_card-content-bottom">
            <Box className="margin-top margin-small">
              <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
            </Box>
            {button && (
              <Box className="margin-top margin-medium button-icon">
                <Variants.LinkButtonIcon href={link}>
                  {button}
                </Variants.LinkButtonIcon>
              </Box>
            )}
          </Box>
        </Box>
      </Variants.LinkText>
    </Box>
  )
);

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0] ?? {},
};
ContentCollectionItem.defaultProps =
  getDefaultProps<ContentCollectionItemType>(itemDefaults);
